import React, { useEffect, useMemo, useRef, useState } from "react";
import { FormLabel, Row, Col, ProgressBar } from "react-bootstrap";
import { Chart } from "react-google-charts";
import CustomTable from "./CustomTable";
import { ColumnDefinition } from "./UIComponents";

export default function PieChart(props) {
  const [serverData, setServerData] = useState([props.data]);
  const [topN, setTopN] = useState(10);

  useEffect(() => {
    setServerData(props.data);
  }, [props.data]);

  // console.log("data pichart", props.data);

  const sortedData = useMemo(() => {
    return [...serverData].sort((a, b) => b.accessor - a.accessor);
  }, [serverData]);

  /************  Pie Chart Data  ****************/
  const chartData = useMemo(() => {
    if (!sortedData.length) return [];

    const topItems = sortedData.slice(0, topN);
    const others = sortedData.slice(topN);

    const data = [["Category", "Value"]];
    topItems.forEach((item) => data.push([item.Header, item.accessor]));
    return data;
  }, [sortedData, topN]);

  /************  Other Data  ****************/
  const otherData = useMemo(() => {
    return sortedData.slice(topN);
  }, [sortedData, topN]);

  const handleChange = (e) => {
    setTopN(Number(e.target.value));
  };

  const options = {
    // title: selected === "top10" ? "TOP 10 RECORDS" : "TOP 20 RECORDS",
    title: `Top ${topN} RECORDS`,
    titleTextStyle: {
      fontSize: 20,
      bold: true,
      alignment: "center",
      // marginLeft: "50px",
      // marginRight: "10px",
    },
    chartArea: { width: "100%", height: "80%" },
    pieSliceText: "value",
    // legend: { position: "right" },
  };

  const getOtherColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Category", "Header", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Value", "accessor", true, true)
        .setStyleDetails("right", "", "", "min-wt-5", "min-wt-5")
    );

    return columns;
  };

  return (
    <div className="p-4">
      <div className="div_inline_justify">
        <div className="div_70_no_overflow">
          <Row>
            <Col sm="2">
              <div className="analytics-label p-1 mb-4">Select Record</div>
            </Col>

            <Col>
              <select
                value={topN}
                //   onChange={(e) => setTopN(Number(e.target.value))}
                onChange={(e) => handleChange(e)}
                className="border p-2 rounded mb-4 w-25 h-50"
              >
                <option value={10}>Top 10</option>
                <option value={20}>Top 20</option>
              </select>
            </Col>
          </Row>
          {chartData.length > 0 ? (
            <Chart
              chartType="PieChart"
              data={chartData}
              options={options}
              width={"100%"}
              height={"400px"}
            />
          ) : (
            <p>No Data </p>
          )}
        </div>
        <div className="div_30_no_overflow">
          {otherData.length > 0 && (
            <div className="p-10 h-75">
              <CustomTable
                label={"Other Datas"}
                columns={getOtherColumns()}
                data={otherData}
                enableVritualizer={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
